var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding"},[_c('AttributeGroupQuestion',{attrs:{"index":_vm.page_index,"property_group":_vm.local_groups[_vm.page_index]},on:{"selected":_vm.selected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }